import { render, staticRenderFns } from "./HabitIcon.vue?vue&type=template&id=29f2c792&scoped=true"
import script from "./HabitIcon.vue?vue&type=script&lang=js"
export * from "./HabitIcon.vue?vue&type=script&lang=js"
import style0 from "./HabitIcon.vue?vue&type=style&index=0&id=29f2c792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f2c792",
  null
  
)

export default component.exports